export enum enumReasonCategory {
    All = 0, Deduction = 1, Discount = 2, Return = 4, Void = 8, CreditAdjustment = 16,
}

export class ReasonCode {
    Id: number = -1;
    Summary: string = "";
    ReasonText: string = "";
    ReasonCategory: number = -1;

    static CreateFrom(rc: ReasonCode): ReasonCode {
        var reasonCode: ReasonCode = new ReasonCode();
        reasonCode.Id = rc.Id;
        reasonCode.Summary = rc.Summary;
        reasonCode.ReasonText = rc.ReasonText;
        reasonCode.ReasonCategory = rc.ReasonCategory;
        return reasonCode;
    }
}